export default {
  skipInQuickEditPanel: true,
  skinParamsToIgnore: [],
};
